import type { ComponentProps, ReactNode } from 'react';
import { OptimizedImage, type OptimizedImageEntity } from '@/components/images/optimized-image';
import type { OutcomeHueName } from '@/lib/chart/outcome-hue';
import { cn } from '@/lib/ui/utils';

type Props = Omit<ComponentProps<typeof OptimizedImage>, 'entity' | 'src'> & {
  entity: Omit<Extract<OptimizedImageEntity, { kind: 'outcome' }>, 'hue'> & {
    hue: OutcomeHueName | undefined;
  };
};

export function OutcomeIdentityImage({ entity, ...props }: Props): ReactNode {
  if (entity.hue === undefined) {
    return (
      <span
        role="img"
        aria-label={props.alt}
        aria-hidden={props.alt.length === 0 ? true : undefined}
        className={cn(
          'block shrink-0 bg-background-tertiary',
          props.size,
          props.rounded ?? 'rounded-control',
          props.className,
        )}
      />
    );
  }
  return <OptimizedImage {...props} entity={{ ...entity, hue: entity.hue }} />;
}
